<template>
    <form method="POST" action="/admin/statistics/composition_orders/excel">
        <input type="hidden" name="_token" value="" id="orders_form_token">

        <div class="row">
            <div class="col-md-9">
                <orders-checker></orders-checker>
            </div>
            <div class="col-md-9">
                <div class="col-md-12">
                    <label style="font-size: 15px">
                        <input v-model="is_chosen_all_brands" @change="selectAllBrands()" type="checkbox">
                        Выбрать всё
                    </label>
                </div>
                <br>
                <div class="col-md-2" style="height: 44px" v-for="brand in brands">
                    <div class="form-group">
                        <label>
                            <input type="checkbox" name="brands[]" :value="brand.id" v-model="chosen_brands">
                            {{ brand.title }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <button class="btn btn-primary form-control" @click="load">
                        <span v-show="!show_loader">Выгрузить данные</span>
                        <i v-show="show_loader" class="fa fa-spinner fa-spin" style="font-size:24px"></i>
                    </button>
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success form-control">
                        <i class="fa fa-file-excel-o"></i>
                        Сохранить в Excel
                    </button>
                </div>
            </div>
            <div class="col-md-12">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th v-for="column in columns">{{ column.title }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(variant, key) in variants">
                        <td><b>{{ key + 1 }}.</b></td>
                        <td>{{ variant.variant_title }}</td>
                        <td>{{ variant.product_title }}</td>
                        <td>{{ variant.brand_title }}</td>
                        <td>{{ variant.count }}</td>
                        <td>{{ variant.purchase_price }}</td>
                        <td>{{ variant.price }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    props: ['brands'],
    mounted: function() {
        Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        document.querySelector('#orders_form_token').value = document.querySelector('#token').getAttribute('content');
    },
    data: function () {
        let columns = [
            { code: 'title', title: 'Упаковка' },
            { code: 'name', title: 'Название' },
            { code: 'name', title: 'Бренд' },
            { code: 'count', title: 'Количество' },
            { code: 'purchase_price', title: 'Закупочная цена' },
            { code: 'price', title: 'Цена' }
        ];

        return {
            order_params: '',
            show_loader: false,
            chosen_brands: this.getIds(this.brands),
            is_chosen_all_brands: true,
            variants: [],
            columns: columns
        };
    },
    methods: {
        validateFields: function () {
            return this.order_params;
        },
        getIds: function (array) {
            let ids = [];

            array.forEach(function (item) {
                ids.push(item.id);
            });

            return ids;
        },
        load: function (event) {
            event.stopPropagation();
            event.preventDefault();
            if (!this.validateFields()) {
                alert('Заполните поле');
                return;
            }
            this.show_loader = true;

            this.$http.post(
                '/statistics/composition_orders/get',
                {
                    brands: this.chosen_brands,
                    order_params: this.order_params,
                }
            ).then(function (response) {
                this.variants = response.data.variants;
                this.show_loader = false;
            }, function (response) {
                this.displayErrors(response);
            });
        },
        selectAllBrands: function () {
            this.is_chosen_all_brands ? this.chosen_brands = this.getIds(this.brands) : this.chosen_brands = [];
        }
    },
    created: function () {
        this.$root.$on('update:order_params', (val) => { this.order_params = val; });
    }
};
</script>
